import { type ReactNode } from 'react';
import { useAccountState } from '@packages/auth';
import { useAuth } from '../auth/useAuth';
import { AccountContext } from './useAccount';

export function AccountProvider({ children }: { children: ReactNode }) {
  const { accountId, user } = useAuth();
  const state = useAccountState(accountId, user?.id ?? null);

  return (
    <AccountContext value={state}>
      {children}
    </AccountContext>
  );
}
